module.exports = __webpack_public_path__ + "fonts/fa-brands-400.7b31967d.ttf";